<template>
    <div class="row register-form smallzer">
        <div class="center col s12 m4 offset-m6">
                <a href="http://www.fyi.io">
                  <img width="210px" height="64px" class='logo' src="./../assets/fyiio-logo-with-name.svg" /> <span v-if="showTitle" style="color:white;font-size:30px;padding: 5px 5px 50px 15px;" class="valign">{{showTitle}}</span>
                </a>
          </div>
    </div>
</template>
<script>

export default {
 props: {
    showTitle: true
  }
}
</script>

<style scoped>
.logo {
        width: 210px;
        height: 64px
    }   
</style>


// WEBPACK FOOTER //
// src/components/FyiioSvgLogo.vue